// Campus photo for /colleges/pomona-college: CC BY-SA 4.0, by Sdkb, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASmith_Clock_Tower_view.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/pomona-college/; credited under the photo.
const photo = {
    "slug": "pomona-college",
    "alt": "Pomona College's campus and the San Gabriel Mountains, seen from the Smith Clock Tower in Claremont, California",
    "src": "/colleges/pomona-college/campus-1600.webp",
    "srcSmall": "/colleges/pomona-college/campus-800.webp",
    "srcMid": "/colleges/pomona-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/pomona-college/og.jpg",
    "title": "Smith Clock Tower view",
    "author": "Sdkb",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASmith_Clock_Tower_view.jpg",
    "read": "2026-09-30"
};

export default photo;
